/** Fallback quando a API já respondeu — enriquecer UI (ex.: data de nascimento só mock). Lista pode ficar vazia. */
export const CLIENTES = []

/**
 * Complemento de UI quando a instalação existe na API (ex.: valor da fatura no mock).
 * Campos usados em instalacoes-detalhe.syncFluxoFromMockRow e clientes-detalhe.valorFaturaMock.
 */
export const INSTALACOES = []

/**
 * Status agregado do checklist do cliente para o badge (StatusBadge).
 */
export function getStatusGeralCliente(checklist) {
  if (!checklist || typeof checklist !== 'object') {
    return 'pendente'
  }
  const d = checklist.status_dados
  const doc = checklist.status_documento
  const steps = [d, doc].filter((s) => s != null && s !== '')
  if (!steps.length) {
    return 'pendente'
  }
  if (steps.some((s) => s === 'reprovado')) {
    return 'reprovado'
  }
  if (steps.every((s) => s === 'aprovado')) {
    return 'aprovado'
  }
  if (steps.some((s) => s === 'enviado')) {
    return 'enviado'
  }
  if (steps.some((s) => s === 'pendente')) {
    return 'pendente'
  }
  return 'em_andamento'
}
